'use client';

import { c as _c } from "react/compiler-runtime";
import { Scene7Image } from '../Scene7Image';
import type { LegacyIconProps } from './types';
export function LegacyIcon(t0) {
  const $ = _c(6);
  const {
    name,
    size,
    isPriority,
    className
  } = t0;
  const iconSrc = `/icons/${name}.png`;
  const t1 = `icon ${name}`;
  const t2 = isPriority ? "eager" : "lazy";
  let t3;
  if ($[0] !== className || $[1] !== iconSrc || $[2] !== size || $[3] !== t1 || $[4] !== t2) {
    t3 = <Scene7Image testId="legacy-icon" src={iconSrc} alt={t1} className={className} loading={t2} width={size} />;
    $[0] = className;
    $[1] = iconSrc;
    $[2] = size;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}